import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { DigoService } from 'src/app/services/digo.service';
import { PermissionService } from 'src/app/shared/services/permission.service';
import { switchMap} from 'rxjs/operators';
import { Ipdv } from 'src/app/shared/models/pdvResponse';
import { allPermissions } from 'src/app/shared/permissions';

@Injectable({
    providedIn: 'root'
})
class SimyoGuardDuplicados  {
    constructor(
        private permSv: PermissionService,
        private router: Router,
        private digoService: DigoService
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        return this.digoService.getPDV()
            .pipe(
                switchMap((response: Ipdv) =>{
                    if (!this.permSv.hasPermFromV2(allPermissions.simyo.permite_duplicado_sim)) {
                        this.router.navigate(['/']);
                        return of(false);
                    }
                    return of(true);
                })
            );
    }
  
}

export const SimyoGuardDuplicadosGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(SimyoGuardDuplicados).canActivate(next, state);
};
